// Formatea fechas de viaje de un lead de forma compacta en español.
// dep/ret vienen como ISO "2026-09-08T00:00:00Z". Ignora placeholders (0001...).
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

function _d(s) {
  if (!s || typeof s !== "string" || s.startsWith("0001")) return null;
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? null : dt;
}

export function formatTravelDates(dep, ret) {
  const d = _d(dep);
  const r = _d(ret);
  if (!d && !r) return "";
  const day = (x) => x.getUTCDate();
  const mon = (x) => MES[x.getUTCMonth()];
  const yr = (x) => x.getUTCFullYear();
  if (d && r) {
    if (mon(d) === mon(r) && yr(d) === yr(r)) return `${day(d)}–${day(r)} ${mon(r)} ${yr(r)}`;
    if (yr(d) === yr(r)) return `${day(d)} ${mon(d)} – ${day(r)} ${mon(r)} ${yr(r)}`;
    return `${day(d)} ${mon(d)} ${yr(d)} – ${day(r)} ${mon(r)} ${yr(r)}`;
  }
  const x = d || r;
  return `${day(x)} ${mon(x)} ${yr(x)}`;
}
